/*@ngInject*/
const AuthenticationUtil = function ($rootScope, $state, $stateParams, $q, $location, $interval, cryptoUtil, coreMediator, uiPerformanceLoggerConstant, coreConstant, checkAuthRepository, logUtil, refreshLoginTokenUtil) {

    this.attemptAutoAuthentication = function () {
        let defer = $q.defer(),
            ssoLogin = !_.isNil($stateParams.login) ? $stateParams.login : null,
            ssoExternalToken = $stateParams.externalToken,
            consoleTypeAuthorizationName,
            passwordIsToken = ssoExternalToken === 'false' || _.isNil(ssoExternalToken),
            isExternalToken = !passwordIsToken,
            ssoTokenSplits,
            username,
            password,
            excludedStates = [
                'password'
            ],
            isOnlyIndexHtml = _.isEmpty($state.current.name) && _.isEmpty($location.path());

        function onCheckAuthSuccess(loginToken) {
            if (loginToken !== coreMediator.getLoginToken()) {
                // Remove the login details if there was no response in checking the session, as this indicates the
                // token has expired.
                coreMediator.removeLoginToken();
                coreMediator.removeClientId();
                defer.reject();
            } else {
                refreshLoginTokenUtil.start(loginToken).then(function () {
                    logUtil.logInfo('Active Session exists, auto-logging into the client.');
                    defer.resolve(!isOnlyIndexHtml);
                });

                if ($state.current.name === 'login' || $location.path().indexOf('login') > -1) {
                    $state.go('landing');
                }
            }
        }

        function onCheckAuthError() {
            // Remove the login details if there was an error checking the session, as this may indicate the
            // token has expired.
            coreMediator.removeLoginToken();
            coreMediator.removeClientId();
            defer.reject();
        }

        function handleLoginSuccess() {
            defer.resolve(!isOnlyIndexHtml && _.isEmpty($stateParams.login));
        }

        function handleLoginError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, uiPerformanceLoggerConstant.LOGIN, coreConstant.uiPeformanceLogger.FAIL);
            handleLoginAuthError();
        }

        function handleLoginAuthError() {
            cryptoUtil.initServerPublicKey();
            defer.reject();
        }

        function validatedExistingAuthentication() {
            if (!_.includes(excludedStates, $state.current.name)) {
                if (!_.isNil(ssoLogin)) {
                    if (_.includes(ssoLogin, ':')) {
                        ssoTokenSplits = _.split(ssoLogin, ':');

                        if (ssoTokenSplits.length === 2) {
                            username = ssoTokenSplits[0];
                            password = ssoTokenSplits[1];

                            cryptoUtil.initServerPublicKey().then(() => {
                                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGIN, null);
                                coreMediator.login(username, password, null, passwordIsToken, isExternalToken).then(handleLoginSuccess, handleLoginError);
                            });
                        } else {
                            handleLoginAuthError();
                        }
                    } else {
                        handleLoginAuthError();
                    }
                } else {
                    if (!_.isNil(coreMediator.getLoginToken())) {
                        checkAuthRepository.checkAuth().then(onCheckAuthSuccess, onCheckAuthError).finally(cryptoUtil.initServerPublicKey);
                    } else {
                        handleLoginAuthError();
                    }
                }
            } else {
                handleLoginAuthError();
            }
        }

        // Whenever we load the application, ensure the ClientID is cleared. We need this to happen because
        // if you click on a link inside the application, it will *not* start a new session, and therefore the
        // ClientID from the application that you clicked the link within will be used in the new tab, and will
        // cause unwanted behavior relating to the persistent connection.
        // This is also important for being able to support different sessions with the server per-browser-tab rather
        // than per-user.
        coreMediator.removeClientId();
        validatedExistingAuthentication();

        return defer.promise;
    };
};

angular.module('gw-um-auth')
    .service('authenticationUtil', AuthenticationUtil);
